import { navigate } from "gatsby"
import React from "react"
import { ProductsPaginedView } from "./ProductsPagined.view"

interface Props {
  className?: string
  pageContext: {
    data: any
    categoryId: string
    categoryName: string
    type: string
    filters: any[]
    producTypeId: any
    description: string
    contenuSEO: string
    liens_haut_page: string
    liens_bas_page: string
    titre_lien_bas_page: string
    faq: { question: string; reponse: string }
    seoTitle: string
    seoDescription: string
    Marque: string
    DescriptionMarque: any
    LogoMarque: any
    LiensAssocies: any
    ImageMarque: any
  }
  data: any
}

export function ProductsPaginedContainer({ pageContext, data }: Props) {
  let seoTitle
  let seoDescription

  if(pageContext?.category){
    seoTitle = pageContext?.category?.seoTitle
    seoDescription = pageContext?.category?.seoDescription
  }else if(pageContext?.collection){
    seoTitle = pageContext?.collection?.seoTitle
    seoDescription = pageContext?.collection?.seoDescription
  }

  let categoryName = pageContext.categoryName

  if (!seoTitle) {
    seoTitle =
      categoryName == "Nouveautés" || categoryName == "Promotions"
        ? "Découvrez nos " + categoryName + " "
        : categoryName + " dans les Plus Grandes Marques de Luxe"
  }

  if (!seoDescription) {
    seoDescription =
      "Retrouvez tous les produits " +
      categoryName +
      ". Grandes-Marques.fr vous propose le meilleur des grandes marques françaises et européennes de décoration et de linge de maison pour votre intérieur. Découvrez l’art de vivre à la Française."
  }

  return (
    <ProductsPaginedView
      products={pageContext.products}
      filters={pageContext.filters}
      onFiltersChange={() => {
        let url = new URL(window.location.href)
        const regex = /\/+page.\/+/s

        let urlFinal = new URL(url.pathname.replace(regex, ""), url)
        urlFinal.pathname = (urlFinal.pathname + "/voir-tout").replace(
          "//",
          "/"
        )
        const slug = urlFinal.pathname + url.search
        return url && navigate(slug)
      } }
      totalCount={pageContext.totalCount}
      categoryName={categoryName}
      description={pageContext.description}
      contenuSEO={pageContext.contenuSEO}
      liens_haut_page={pageContext.liens_haut_page}
      liens_bas_page={pageContext.liens_bas_page}
      faq={pageContext.faq}
      seoTitle={seoTitle}
      seoDescription={seoDescription}
      pageInfo={pageContext.pageInfo}
      titre_lien_bas_page={pageContext.titre_lien_bas_page}
      Marque={pageContext.Marque}
      DescriptionMarque={pageContext.DescriptionMarque}
      LogoMarque={pageContext.LogoMarque}
      LiensAssocies={pageContext.LiensAssocies}
      ImageMarque={pageContext.ImageMarque}
      // On passe soit la category soit l'id de la catergory lier (dans le cas d'une collection) pour requêter plus tard (breadcrumbs )
      category={data?.saleor?.category || {
        id: data.allStrapiCollectionContent?.edges[0]?.node?.categorie_mere
          ?.saleor_id,
      }} 
      />
  )
}
